<form (ngSubmit)="save()">
    <div class="modal-content" id="notification-form-modal">
        <div class="modal-header">
            <span class="modal-title pull-left" [translate]="'notifications.edit-notif'">
            </span>
            <button type="button" class="btn-close pull-right" aria-label="Close" (click)="activeModal.dismiss('cancel')">
            </button>
        </div>

        <div class="modal-body">
            <div class="container">

                <div class="row">
                    <div class="col-12">
                        <mtx-alert-display [alerts]="messages"></mtx-alert-display>
                    </div>
                </div>

                <div class="row mb-3">
                  @if (anyEmail() && !userInfo?.email_verified) {
                    <small class="text-danger text-center col-12 p-0" [translate]="'notifications.email_verification_error'"></small>
                  }
                  @if (!userInfo?.phone) {
                    <small class="text-danger text-center col-12 p-0"><span [translate]="'notifications.phone_missing_error'"></span><a class="text-danger" target="_blank" rel="noopener" href="{{environment.oauthConfig.issuer}}/account/#/personal-info"><u [translate]="'general.here'"></u>.</a></small>
                  } @else if (!userInfo?.phone_verified) {
                    <small class="text-danger text-center col-12 p-0" [translate]="'notifications.phone_verification_error'"></small>
                  }

                    <div style="min-width: 50%; text-align: center; width: auto">
                        <h6>
                            {{userInfo?.email}}
                            <br/>
                        </h6>
                    </div>
                    <div class="col-4 text-center w-auto">
                        <h6>
                            {{userInfo?.phone}}
                            <br/>
                        </h6>
                    </div>
                </div>

                <mtx-loading-dialog [watch]="loading"></mtx-loading-dialog>

                <div class="row">
                    @for (row of notifs; track row.notification_type) {
                        <div class="col-lg-6">
                            <span [translate]="row.label"></span>

                            <span class="float-lg-end">
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input type="checkbox" [checked]="row.send_email" (change)="toggleEmailNotification(row)"
                                            class="form-check-input" [disabled]="!row.can_set_email" />
                                        <i class="ati-mail"></i>
                                    </label>
                                </div>
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input type="checkbox" [checked]="row.send_mobile" (change)="toggleMobileNotification(row)"
                                            class="form-check-input" [disabled]="!row.can_set_sms" />
                                        <i class="ati-phone"></i>
                                    </label>
                                </div>
                            </span>
                        </div>
                    }
                </div>

                @if (loaded && notifs.length === 0) {
                    <div class="row">
                        <p class="col-12 text-center" [translate]="'notifications.none_available'"></p>
                    </div>
                }

            </div>

                @if (anyMobile()) {
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="sms-consent-check"
                                    [(ngModel)]="smsConsent" [ngModelOptions]="{standalone: true}" />
                                <label class="form-check-label" for="sms-consent-check">
                                    {{ 'notifications.sms_consent' | translate: { phone: userInfo?.phone } }}
                                </label>
                            </div>
                        </div>
                    </div>
                }

            <div class="modal-footer">
                <button type="submit" class="btn btn-default btn-submit" value="Submit" id="save-btn" [translate]="'general.submit'" [disabled]="saving || notifs.length === 0 || (anyMobile() && !smsConsent)"></button>
                <button type="button" class="btn btn-default" data-dismiss="modal" (click)="activeModal.dismiss('cancel')" [translate]="'general.close'"></button>
            </div>

        </div>
    </div>
</form>
